"use client";

import React, { useState } from 'react';

interface Faq {
    question: string;
    answer: string;
}

interface Props {
    faqs: Faq[];
    initialCount?: number;
}

const FaqsAccordion = ({ faqs, initialCount = 6 }: Props) => {
    const [showAll, setShowAll] = useState(false);

    const visibleFaqs = showAll ? faqs : faqs.slice(0, initialCount);
    const hasMore = faqs.length > initialCount;

    return (
        <div>
            <div className="space-y-3">
                {visibleFaqs.map((faq, index) => (
                    <details
                        key={index}
                        className="group overflow-hidden transition-all duration-300"
                        style={{
                            background: '#0d2416',
                            border: '1px solid rgba(122,252,32,0.1)',
                            clipPath: 'polygon(0 0, calc(100% - 10px) 0, 100% 10px, 100% 100%, 10px 100%, 0 calc(100% - 10px))',
                        }}
                    >
                        <summary className="list-none [&::-webkit-details-marker]:hidden flex justify-between items-center p-5 cursor-pointer select-none gap-4">
                            <span
                                className="font-black text-sm leading-snug pr-2 transition-colors duration-200 group-open:text-[#7AFC20]"
                                style={{ color: '#F5F5DC' }}
                            >
                                {faq.question}
                            </span>
                            <div
                                className="flex-shrink-0 w-7 h-7 flex items-center justify-center transition-all duration-300 group-open:rotate-45"
                                style={{
                                    background: 'rgba(122,252,32,0.1)',
                                    border: '1px solid rgba(122,252,32,0.3)',
                                    color: '#7AFC20',
                                }}
                            >
                                <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M12 4v16m8-8H4" />
                                </svg>
                            </div>
                        </summary>
                        <div
                            className="px-5 pb-5 text-sm leading-relaxed"
                            style={{ color: 'rgba(245,245,220,0.5)', borderTop: '1px solid rgba(122,252,32,0.08)' }}
                        >
                            <div className="pt-4" dangerouslySetInnerHTML={{ __html: faq.answer }} />
                        </div>
                    </details>
                ))}
            </div>

            {hasMore && (
                <button
                    onClick={() => setShowAll((prev) => !prev)}
                    className="group mt-4 flex items-center justify-center gap-2.5 w-full py-3 font-black text-xs uppercase tracking-[0.2em] transition-all duration-300 hover:-translate-y-0.5 focus:outline-none"
                    style={{
                        border: '1px solid rgba(122,252,32,0.3)',
                        color: '#7AFC20',
                        background: 'rgba(122,252,32,0.05)',
                        clipPath: 'polygon(0 0, calc(100% - 10px) 0, 100% 10px, 100% 100%, 10px 100%, 0 calc(100% - 10px))',
                    }}
                >
                    {showAll ? (
                        <>
                            Show Less
                            <svg
                                className="w-4 h-4 transition-transform duration-300 group-hover:-translate-y-0.5"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                strokeWidth={2.5}
                            >
                                <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 15.75l7.5-7.5 7.5 7.5" />
                            </svg>
                        </>
                    ) : (
                        <>
                            Show More
                            <svg
                                className="w-4 h-4 transition-transform duration-300 group-hover:translate-y-0.5"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                strokeWidth={2.5}
                            >
                                <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                            </svg>
                        </>
                    )}
                </button>
            )}
        </div>
    );
};

export default FaqsAccordion;
